export default __webpack_public_path__ + "static/red-cross-10dbc3af6b23f3d9692c712726a4309a.png";